import dayjs, { getDefaultFormat, getTimeDefaultFormat, utc2local } from '../_util/day';
import { calc } from '../_util/utils';
export const getColorConfig = _ref => {
  let {
    prefixClass,
    colors
  } = _ref;
  let list = [colors["--".concat(prefixClass, "-lakeblue-senior-color")], colors["--".concat(prefixClass, "-vibrantgreen-senior-color")], colors["--".concat(prefixClass, "-yellow-senior-color")], colors["--".concat(prefixClass, "-lightyellow-senior-color")], colors["--".concat(prefixClass, "-grassgreen-senior-color")], colors["--".concat(prefixClass, "-peacockblue-senior-color")], colors["--".concat(prefixClass, "-grayblue-senior-color")], colors["--".concat(prefixClass, "-lilac-senior-color")], colors["--".concat(prefixClass, "-graypink-senior-color")]];
  let result = [];
  for (let i = 0; i < 100; i++) {
    result = result.concat(list);
  }
  return result;
};
export const getTooltipConfig = _ref2 => {
  let {
    prefixClass,
    colors,
    extra,
    xFormatter,
    yFormatter
  } = _ref2;
  return {
    trigger: 'axis',
    confine: true,
    // 将tooltip限制在图表区域内
    transitionDuration: 0.1,
    // 移动动画过度时间
    position: function (point) {
      return [point[0] + 12, point[1] + 12];
    },
    backgroundColor: colors["--".concat(prefixClass, "-elevation-8")],
    borderWidth: 0,
    padding: 0,
    textStyle: {
      color: colors["--".concat(prefixClass, "-onSurface-med-color")]
    },
    formatter(params) {
      const title = xFormatter ? xFormatter(params[0].axisValue) : params[0].axisValue;
      return "\n        <div class=\"".concat(prefixClass, "-chart-tooltip\">\n          <div class=\"tooltip-title\">\n            <div>").concat(title, "</div>\n            <div>").concat(extra || '', "</div>\n          </div>\n          <div class=\"tooltip-content\">\n            ").concat(params.map(item => {
        var _item$data, _item$data$key, _item$data2;
        const keyIdx = item.encode.y[0];
        const key = item.dimensionNames[keyIdx];
        const value = item.data ? yFormatter ? yFormatter((_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data[key]) : (_item$data$key = (_item$data2 = item.data) === null || _item$data2 === void 0 ? void 0 : _item$data2[key]) !== null && _item$data$key !== void 0 ? _item$data$key : '-' : '-';
        return "\n                  <div class=\"tooltip-content-row\">\n                    <i style=\"color: ".concat(item.color, ";\">\n                    </i>\n                    <label>").concat(item.seriesName, "</label>\n                    <b>").concat(value, "</b>\n                  </div>\n                ");
      }).join(''), "\n          </div>\n        </div>\n      ");
    }
  };
};
const round = value => {
  return calc.div(Math.round(calc.mul(value, 100)), 100) + '';
};
export const bigValueFormatter = value => {
  if (typeof value !== 'number') {
    return ' - ';
  }
  const isFu = value < 0;
  value = Math.abs(value);
  let result = round(value) + ' ';
  if (value >= Math.pow(10, 12)) {
    result = round(calc.div(value, Math.pow(10, 12))) + ' T';
  } else if (value >= Math.pow(10, 9)) {
    result = round(calc.div(value, Math.pow(10, 9))) + ' G';
  } else if (value >= Math.pow(10, 6)) {
    result = round(calc.div(value, Math.pow(10, 6))) + ' M';
  } else if (value >= Math.pow(10, 3)) {
    result = round(calc.div(value, Math.pow(10, 3))) + ' K';
  }
  return isFu ? "-".concat(result) : result;
};
export const timeFormatter = (time, format, isUtcTimeZone) => {
  let _format = undefined;
  switch (format) {
    // 年月 MMM, YYYY
    case 'YM':
      _format = getDefaultFormat('month', false);
      break;
    // 年月日 MMM DD, YYYY
    case 'YMD':
      _format = getDefaultFormat('date', false);
      break;
    // 月日 MMM DD
    case 'MD':
      _format = getDefaultFormat('MD', false);
      break;
    // 月日时分（换行） MMM DD \n HH:mm
    case 'MDHm':
      _format = getDefaultFormat('MD', false) + ' ' + getTimeDefaultFormat('HM');
      break;
    // 时分 HH:mm
    case 'Hm':
      _format = getTimeDefaultFormat('HM');
      break;
    default:
      // 年月日时分秒 MMM DD, YYYY HH:mm:ss
      _format = getDefaultFormat('date', 'HMS');
      break;
  }
  return utc2local(time, {
    format: _format,
    isUtcTimeZone
  });
};
export const formatTimeByDiff = (time, range, isUtcTimeZone) => {
  try {
    const start = dayjs(range.start);
    const end = dayjs(range.end);
    // 开始和结束在同一天，显示 HH:mm
    if (end.isSame(start, 'day')) {
      return timeFormatter(time, 'Hm', isUtcTimeZone);
    }
    // 开始和结束间隔<=30天，显示 MMM DD HH:mm
    if (end.subtract(30, 'day').isBefore(start)) {
      return timeFormatter(time, 'MDHm', isUtcTimeZone);
    }
    // 开始和结束间隔<=360天，显示 MMM DD
    if (end.subtract(360, 'day').isBefore(start)) {
      return timeFormatter(time, 'MD', isUtcTimeZone);
    }
    // 开始和结束间隔>360天，显示 MMM DD, YYYY
    return timeFormatter(time, 'YMD', isUtcTimeZone);
  } catch (error) {
    return '-';
  }
};
export const getLightColor = (color, alpha) => {
  // 解析颜色为RGBA对象
  const parseHex = hex => {
    hex = hex.replace(/^#/, '').toLowerCase();
    const is8Bit = hex.length === 8;
    const is4Bit = hex.length === 4;
    const r = is4Bit ? "0x".concat(hex[0]).concat(hex[0]) : "0x".concat(hex[0]).concat(hex[1]);
    const g = is4Bit ? "0x".concat(hex[1]).concat(hex[1]) : "0x".concat(hex[2]).concat(hex[3]);
    const b = is4Bit ? "0x".concat(hex[2]).concat(hex[2]) : "0x".concat(hex[4]).concat(hex[5]);
    const a = is8Bit ? parseInt("0x".concat(hex[6]).concat(hex[7]), 16) / 255 : is4Bit ? parseInt("0x".concat(hex[3]).concat(hex[3]), 16) / 255 : 1;
    return {
      r: parseInt(r, 16),
      g: parseInt(g, 16),
      b: parseInt(b, 16),
      a
    };
  };
  const parseRgb = str => {
    const match = str.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/i);
    if (!match) return null;
    return {
      r: parseInt(match[1]),
      g: parseInt(match[2]),
      b: parseInt(match[3]),
      a: match[4] ? parseFloat(match[4]) : 1
    };
  };

  // 统一处理输入格式
  let rgba = null;
  if (color.startsWith('#')) {
    rgba = parseHex(color);
  } else if (color.startsWith('rgb')) {
    rgba = parseRgb(color);
  }
  if (!rgba) throw new Error('Invalid color format');
  if (typeof alpha !== 'number' || alpha < 0 || alpha > 1) throw new Error('Invalid color alpha');

  // 计算新透明度（保留3位小数确保精度）
  const newA = (rgba.a * alpha).toFixed(3);

  // 返回标准化的rgba字符串
  return "rgba(".concat(rgba.r, ", ").concat(rgba.g, ", ").concat(rgba.b, ", ").concat(newA, ")");
};
const yAxisLadders = [10, 20, 30, 40, 50, 60, 80, 100, 120, 150, 180, 200, 250, 300, 400, 500, 600, 800].concat([1, 1.2, 1.5, 1.8, 2, 2.5, 3, 4, 5, 6, 8].flatMap(n => [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(e => n * Math.pow(10, e))).toSorted((a, b) => a - b));
export const getyAxisMax = (max, min) => {
  const minIdx = min ? yAxisLadders.findIndex(it => it >= min) : 0;
  const maxIdx = yAxisLadders.slice(minIdx).findIndex(it => max < it);
  return yAxisLadders[Math.max(maxIdx, 0)];
};